import React, { FunctionComponent } from 'react';
import { Check } from '../../../icons/components';
import LoaderDotsIcon from '../../../icons/components/LoaderDots';

import { Text } from '../Text';

export const Loader: FunctionComponent<{ isLoading: boolean, title?: string, subTitle?: string }> = ({ isLoading }) => {
    return (
        <div className={`c-loader-react ${isLoading ? 'loader--is-loading' : ''}`}>
            <div className="loader__modal">
                <Text as="h2">We zijn uw afspraak aan het maken</Text>

                <div className="loader__text">
                    <Check width={18} height={12} />
                    Een moment geduld
                </div>

                <LoaderDotsIcon width={100} height={100} />
            </div>
        </div>
    );
};
